import { Autocomplete, Paper, Skeleton, TextField, Typography } from "@mui/material";

import { textAreaStyles } from "../../../../cm/Dashboard/FullPages/constant";
import Colors from "../../../../global/Colors";

const AssignmentSection = ({
  roleOptions,
  selectedRole,
  handleRoleSelect,
  selectedActingUser,
  assignableUserOptions,
  handleActingUserSelect,
  setUserSearch,
  setRoleSearch,
  isLoading = false,
  disabled = false,
}) => {
  const roleDisabled = disabled || !!selectedActingUser;
  const userDisabled = disabled || !!selectedRole;

  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2 }} className="mx-3 shadow-md">
      <Typography
        variant="subtitle1"
        sx={{ mb: 1, fontWeight: 500 }}
        style={{
          color: Colors.gray[400],
        }}
      >
        Assignment
      </Typography>
      {isLoading ? (
        <div className="w-full">
          <Skeleton variant="rounded" height={56} sx={{ width: "100%", mb: 2 }} />
          <Skeleton variant="rounded" height={56} sx={{ width: "100%", mb: 2 }} />
          <Skeleton variant="text" width={240} />
        </div>
      ) : (
        <>
          <Autocomplete
            className="w-full"
            disablePortal
            options={roleOptions ?? []}
            getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            noOptionsText="No Results"
            sx={{
              width: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onChange={handleRoleSelect}
            value={selectedRole ?? null}
            disabled={roleDisabled}
            renderOption={(props, option) => (
              <li {...props} id={`${option.id}`} key={`${option.id}`}>
                {option?.label ?? option?.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Role"
                placeholder="Select a role"
                className="w-full text-center"
                sx={{ ...textAreaStyles }}
                onChange={(e) => setRoleSearch?.(e.target.value)}
                onBlur={() => setRoleSearch?.("")}
              />
            )}
          />
          <Autocomplete
            className="mb-2 mt-4 w-full"
            disablePortal
            options={assignableUserOptions ?? []}
            getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            noOptionsText="No Results"
            sx={{
              width: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onChange={handleActingUserSelect}
            value={selectedActingUser ?? null}
            disabled={userDisabled}
            renderOption={(props, option) => (
              <li {...props} id={`${option.id}`} key={`${option.id}`}>
                {option?.label ?? option?.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="User"
                placeholder="Search user"
                className="w-full text-center"
                sx={{ ...textAreaStyles }}
                onChange={(e) => setUserSearch(e.target.value)}
                onBlur={() => setUserSearch("")}
              />
            )}
          />
          <Typography
            variant="span"
            style={{
              color: Colors.gray[400],
              fontSize: "12px",
            }}
          >
            Please select a User or a Role responsible for this action item
          </Typography>
        </>
      )}
    </Paper>
  );
};

export default AssignmentSection;
